import * as tokens from '@utmost.co/utmost-design-tokens';
import { token, tokenToPx } from './getToken';

export const ELEVATION = {
  level0: {
    boxShadow: tokens.elevationLevel0 // --shadow-none
  },
  level1: {
    boxShadow: tokens.elevationLevel1 // --shadow-weak
  },
  level2: {
    boxShadow: tokens.elevationLevel2 // --shadow-moderate
  },
  level3: {
    boxShadow: tokens.elevationLevel3 // --shadow-strong
  },
  level4: {
    boxShadow: tokens.elevationLevel4 // --shadow-stronger
  },
  level5: {
    boxShadow: tokens.elevationLevel5 // --shadow-strongest
  }
};

export const DEFAULT_BUTTON_INPUT_ELEVATION = {
  boxShadow: tokens.elevationLevel1
};

export const ICON = {
  size: {
    small: token('sizeIconXxxs'),
    medium: token('sizeIconXs'),
    large: token('sizeIconMd')
  }
};

export const SPACING_SIZES = {
  none: 0,
  xs: tokenToPx('spacingXxxs'),
  s: tokenToPx('spacingXxs'),
  m: tokenToPx('spacingXs'),
  ml: tokenToPx('spacingSm'),
  l: tokenToPx('spacingMd'),
  ll: tokenToPx('spacingLg'),
  xl: tokenToPx('spacingXl'),
  xxl: tokenToPx('spacingXxl'),
  xxxl: tokenToPx('spacingXxxl')
};

export const FONT = {
  family: `${token('fontFamilyProduct')}, 'Helvetica Neue', 'Helvetica', Arial, sans-serif`,
  size: {
    xxSmall: tokenToPx('labelSmallFontSize'),
    xSmall: tokenToPx('bodySmallFontSize'),
    small: tokenToPx('bodyMediumFontSize'),
    medium: tokenToPx('bodyLargeFontSize'),
    large: tokenToPx('titleLargeFontSize')
  },
  weight: {
    light: `var(--font-weight-thin, 300)`,
    regular: token('fontWeightRegular'),
    medium: token('fontWeightMedium'),
    mediumBold: `var(--font-weight-medium-bold, 600)`,
    bold: `var(--font-weight-bold, 700)`
  }
};
